import type { SVGProps } from "react";
export interface Arrow04LeftIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function Arrow04LeftIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: Arrow04LeftIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M20.876 10.904c0-.44-.002-.701-.018-.895-.015-.18-.036-.2-.023-.176a.38.38 0 0 0-.165-.164 1 1 0 0 0-.177-.025 13 13 0 0 0-.892-.016h-8.1a1.125 1.125 0 0 1-1.125-1.125V4.958l-6.446 6.12a13 13 0 0 0-.67.66c-.127.142-.126.174-.116.146a.38.38 0 0 0 0 .24c-.01-.029-.01.003.117.146.136.153.336.343.67.66l6.445 6.118v-3.543c0-.621.504-1.125 1.125-1.125h8.1c.438 0 .699 0 .892-.016a1 1 0 0 0 .178-.025.38.38 0 0 0 .164-.164c-.013.024.008.004.023-.176.016-.194.018-.456.018-.895zm2.25 2.2c0 .402 0 .771-.025 1.078-.026.32-.085.67-.261 1.015a2.63 2.63 0 0 1-1.147 1.147 2.7 2.7 0 0 1-1.015.262c-.307.025-.676.024-1.077.024h-6.975v3.175c0 .272 0 .552-.02.778-.017.194-.064.611-.361.966a1.63 1.63 0 0 1-1.342.577c-.463-.028-.798-.282-.95-.403-.179-.141-.381-.335-.578-.521l-6.995-6.64c-.305-.29-.585-.556-.798-.794a3 3 0 0 1-.458-.655l-.112-.271a2.63 2.63 0 0 1 0-1.676c.129-.382.349-.678.57-.926.213-.239.493-.504.798-.794l6.995-6.64.296-.278q.146-.137.281-.243c.153-.121.489-.375.95-.403h.193c.38.022.74.177 1.018.438l.132.139.1.135c.208.32.246.66.262.83.02.226.019.507.019.778v3.176H19.6c.401 0 .77-.002 1.077.023.32.026.67.086 1.015.262.494.252.895.654 1.147 1.147.176.346.235.696.26 1.016.026.306.026.676.026 1.078v2.2Z"
      />
    </svg>
  );
}
